module.exports = __webpack_public_path__ + "img/check.07e336f7.svg";